/**
 * Tasa preferencial de plazo fijo (migración 0395).
 * Solo los usuarios en parametro_sistema 'pf.tasa_preferencial.autorizados' pueden pactar tasa ≠ 12%,
 * y el server exige que hayan confirmado su clave hace < 10 min (claim `amr` del JWT).
 * confirmarClave() re-autentica al MISMO usuario con su clave de NeoCore → token nuevo con amr fresco.
 */
import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'

export function usePuedeTasaPreferencial(activo: boolean) {
  const [puede, setPuede] = useState(false)
  useEffect(() => {
    if (!activo) return
    supabase.rpc('pf_puede_tasa_preferencial').then(({ data }) => setPuede(data === true))
  }, [activo])
  return puede
}

export async function confirmarClave(clave: string): Promise<string | null> {
  const { data: u } = await supabase.auth.getUser()
  const email = u.user?.email
  if (!email) return 'No se pudo identificar tu usuario. Volvé a iniciar sesión.'
  const { error } = await supabase.auth.signInWithPassword({ email, password: clave })
  return error ? 'Clave incorrecta.' : null
}
